<script setup lang="ts">
import { computed } from 'vue'
import { useDocumentStore } from '@/stores/documentStore'
import { useI18n } from '@/i18n'

const docStore = useDocumentStore()
const { t } = useI18n()
const comps = computed(() => {
  void docStore.historyVersion
  return docStore.doc?.comps ?? []
})
function rename(id: string, cur: string) {
  const n = prompt(t('layer.name'), cur)
  if (n && n !== cur) docStore.renameLayerComp(id, n)
}
</script>

<template>
  <div class="panel">
    <div class="panel-title row"><span>{{ t('panel.comps') }}</span><span class="spacer" /><button class="icon ghost" :title="t('comps.add')" :disabled="!docStore.hasDocument" @click="docStore.addLayerComp()">＋</button></div>
    <div class="list">
      <div v-if="!comps.length" class="empty muted">{{ t('comps.empty') }}</div>
      <div v-for="c in comps" :key="c.id" class="comp" @dblclick="rename(c.id, c.name)">
        <button class="ghost tiny" :title="t('comps.apply')" @click="docStore.applyLayerComp(c.id)">▶</button>
        <span class="name">{{ c.name }}</span>
        <button class="ghost tiny" :title="t('comps.update')" @click="docStore.updateLayerComp(c.id)">↻</button>
        <button class="ghost tiny" :title="t('comps.delete')" @click="docStore.removeLayerComp(c.id)">🗑</button>
      </div>
    </div>
    <div class="row foot"><button class="ghost" :disabled="!docStore.hasDocument" @click="docStore.addLayerComp()">＋ {{ t('comps.add') }}</button></div>
  </div>
</template>

<style scoped>
.panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.list {
  overflow: auto;
}
.empty {
  padding: 8px 10px;
  font-size: 11px;
}
.comp {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-bottom: 1px solid var(--line-weak);
}
.name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tiny {
  width: 22px;
  height: 20px;
  padding: 0;
}
.foot {
  padding: 4px 8px;
}
</style>
